if (!window.variantSlideshowSectionsReady) {
  window.variantSlideshowSectionsReady = true;

  document.addEventListener('product:variant-change', function (event) {
    var variant = event.detail.variant;

    if (!variant) return;

    document.querySelectorAll('[data-variant-slideshow-section]').forEach(function (section) {
      var sectionId = section.dataset.sectionId;
      var productUrl = section.dataset.productUrl;

      if (!sectionId || !productUrl) return;

      fetch(productUrl + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (responseText) {
          var html = new DOMParser().parseFromString(responseText, 'text/html');
          var updatedSection = html.querySelector('[data-variant-slideshow-section][data-section-id="' + sectionId + '"]');

          if (!updatedSection) return;

          section.querySelectorAll('slide-show').forEach(function (slideshow) {
            if (!window.Flickity) return;

            var flickity = Flickity.data(slideshow);
            if (flickity) flickity.destroy();
          });

          section.replaceWith(updatedSection);
        });
    });
  });
}
